import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Icon2 } from '../';

const AtomButtonStep = ({ url, text, className }) => {
  return (
    <Link to={url} className={`flex px-3 py-2 rounded-lg transition button button-step-large ${className}`}>
      <span>{text}</span>
      <Icon2 icon="angle-right" size="60px" />
    </Link>
  );
};

AtomButtonStep.propTypes = {
  url: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
};

AtomButtonStep.defaultProps = {
  className: "",
};

export default AtomButtonStep;
